import { isNil } from './index';
import getFlattenedConfiguration from '../../redux/selectors/getFlattenedConfiguration';

const resolvePrice = (item, configuration) => {
    if (item.serial_parent_uid !== 0) {
        const flattenedConfiguration =
      getFlattenedConfiguration(configuration);
        const foundParent = flattenedConfiguration.filter(
            (selectedItem) => selectedItem.uid === item.serial_parent_uid
        );

        if (foundParent.length > 0) {
            return 0;
        }
    }
    return item.total_price;
};

const calcPrice = (configuration) => {
    const initPrice = !isNil(configuration.model) ? configuration.model.lowestPrice : 0;
    let price = 0;
    Object.keys(configuration.configurations).forEach(key => {
        if (!isNil(configuration.configurations[key])) {
            if (Array.isArray(configuration.configurations[key])) {
                configuration.configurations[key].forEach(item => {
                    price += resolvePrice(item, configuration.configurations);
                });
            } else {
                price += resolvePrice(
                    configuration.configurations[key], configuration.configurations
                );
            }
        }
    });
    if (price === 0) {
        return initPrice;
    }
    return price;
};
export default calcPrice;
